import React, { Component } from 'react'
import { Toast } from 'react-bootstrap'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { COLORES } from '../../../../config/colores'

class StatusToast extends Component {
  constuctor (props) {}

  render () {
    const {
      onClose,
      message,
      extraMessage = null,
      title,
      show,
      error = false
    } = this.props
    const backgroundColor = error ? COLORES.error : COLORES.success
    return (
      <div aria-live='polite'
        aria-atomic='true'
      >
        <Toast onClose={() => onClose()}
          show={show}
          delay={INTERVALO_CORTO}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            backgroundColor: backgroundColor
          }}>
          <Toast.Header closeButton={false} >
            <strong className='mr-auto'>{title}</strong>
          </Toast.Header>
          <Toast.Body >
            <h5>{message && message}</h5>
            {extraMessage && extraMessage}
          </Toast.Body>
        </Toast>
      </div>
    )
  }
};

export default StatusToast
